import { ReactNode } from 'react';
import { SectionHeaderWrapper, SectionSubTitle, StyledSectionTitle } from './Styled';

type SectionTitleProps = {
  title: string;
  subTitle: ReactNode;
  sectionComponent: ReactNode;
};

export const SectionTitle = ({ title, subTitle, sectionComponent }: SectionTitleProps) => (
  <SectionHeaderWrapper>
    <div>
      <StyledSectionTitle>{title}</StyledSectionTitle>
      <SectionSubTitle>{subTitle}</SectionSubTitle>
    </div>
    <div>{sectionComponent}</div>
  </SectionHeaderWrapper>
);
